<template>
  <div :class="$style['adl-editable-row']">
    <mds-layout-grid>
      <mds-row :class="$style['cf-heading-align']">
        <!--  Row for Heading -->
        <mds-col :cols="12">
          <div :class="$style['cf-heading-title']">{{ title }}</div>
        </mds-col>
      </mds-row>
      <mds-row :class="$style['cf-EditableDataWrap']">
        <mds-col :cols="12" :class="$style['cf-EditableDataWrap-inner']">
          <mds-row
            class="cf-fields"
            v-for="(row, ind) in rows"
            :key="'row-' + ind"
            alignVertical="flex-end"
          >
            <mds-col
              :cols="header.cols"
              v-for="(header, index) in headers"
              :key="'header-' + index"
              :class="$style[header.class]"
              :alignVertical="header.align ? header.align : 'flex-end'"
            >
              <template v-if="header.type === 'Input'">
                <adl-input-format
                  v-if="!header.isEditiable"
                  :label="
                    row[header.key].label ? row[header.key].label : header.label
                  "
                  :isDisabled="header.isdisabled"
                  v-model="row[header.key].value"
                  :isAllowOnlyNumber="header.isAllowOnlyNumber"
                  :currencyFormat="header.currencyFormat"
                  :appendText="header.appendText"
                  :calculateMicrocopyText="header.calculateMicrocopyText"
                  :microcopy-below="row[header.key].microcopyBelow"
                  :maxlength="header.length"
                  :maxvalue="header.max"
                  :AllowOnlyDecimalTill="header.AllowOnlyDecimalTill"
                  @editableRowButtonClick="
                    onChangeEditableInput(header.callBackMethod, ind)
                  "
                ></adl-input-format>

                <div
                  v-if="header.isEditiable"
                  :class="$style['cf-summaryBlock']"
                >
                  <div>
                    {{
                      row[header.key].label
                        ? row[header.key].label
                        : header.label
                    }}
                  </div>
                  <div>
                    <strong>
                      <input-text
                        :currencyFormat="header.currencyFormat"
                        :appendText="header.appendText"
                        :text="row[header.key].value"
                        :drawDownOptions="header.options"
                      ></input-text>
                    </strong>
                  </div>
                </div>
              </template>

              <template v-else-if="header.type === 'EditButton'">
                <mds-button
                  :variation="header.variation"
                  :key="header.key"
                  :icon="header.icon"
                  :size="header.size"
                  :disabled="header.isdisabled"
                  @click="
                    $emit('editableRowButtonClick', header.callBackMethod, rows)
                  "
                  >{{ header.label }}</mds-button
                >
              </template>

              <template v-else-if="headers[index].type === 'Dropdown'">
                <mds-select
                  :placeholder="header.placeholder"
                  :class="header.class"
                  :label="header.label"
                  :align="header.align"
                  :options="header.options"
                  :disabled="header.isdisabled"
                  v-model="row[headers[index].key].value"
                  @change="
                    dropDownChange(
                      header.callBackMethod,
                      row[headers[index].key].value,
                      header.options
                    )
                  "
                  :style="header.style"
                >
                </mds-select>
              </template>
            </mds-col>
          </mds-row>

          <mds-row :class="$style['cf-margin-fields']" alignVertical="flex-end">
            <mds-col
              :cols="header.cols"
              v-for="(header, index) in buttonRow"
              :key="'headerC-' + index"
              :alignVertical="header.align ? header.align : 'flex-end'"
            >
              <template v-if="header.type === 'Button'">
                <mds-button
                  :variation="header.variation"
                  :key="header.key"
                  :disabled="header.isdisabled"
                  @click="
                    $emit('editableRowButtonClick', header.callBackMethod, rows)
                  "
                  >{{ header.label }}</mds-button
                >
              </template>
            </mds-col>
          </mds-row>
        </mds-col>
      </mds-row>
    </mds-layout-grid>
  </div>
</template>

<script>
import Vue from "vue";
import MdsSelect from "@mds/select";
import { MdsButton } from "@mds/button";
import InputText from "./input-text.vue";
import AdlInputFormat from "../input-format/InputFormat.vue";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

export default Vue.extend({
  components: {
    MdsButton,
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsSelect,
    AdlInputFormat,
    InputText,
  },
  props: {
    title: {
      type: String,
    },
    headers: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    isEdit: {
      type: Boolean,
    },
  },
  data() {
    return {
      sortColIndex: 0,
    };
  },
  computed: {
    buttonRow() {
      return this.headers.filter((sr) => sr.type == "Button");
    },
  },

  methods: {
    onChangeEditableInput(callBackMethod, selectedValue) {
      if (callBackMethod) {
        this.$emit("editableRowButtonClick", callBackMethod, selectedValue);
      }
    },
    dropDownChange(callBackMethod, selectedValue, options) {
      if (callBackMethod) {
        let selectedObj = options.filter((sr) => sr.value == selectedValue);
        this.$emit("editableRowButtonClick", callBackMethod, selectedObj[0]);
      }
    },
    numbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    changeFormatToNumber(evt, appendText) {
      let value = evt.target.value;
      if (appendText != "") {
        evt.target.value = value + appendText;
      }
    },
  },
});
</script>

<style lang="scss" module>
@import "@mds/constants";
@import "@mds/typography";
.adl-editable-row {
  .cf-margin-fields {
    margin-top: $mds-space-2-x !important;
  }
  .no-paddingLR {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .cf-EditableDataWrap {
    padding-left: $mds-space-2-x !important;
    padding-right: $mds-space-2-x !important;
    .cf-EditableDataWrap-inner {
      border: $mds-border-separator-on-light;
      padding: $mds-space-1-and-a-half-x;
      border-radius: $mds-space-1-x;
      background-color: #fff;
      position: relative;

      .cf-summaryBlock {
        font-style: normal;
        font-size: 16px;
        font-weight: 300;
        line-height: 21px;
      }
      .flexiblePosition {
        position: absolute;
        top: -38px;
        right: 0px;
        padding-right: 0px;
      }
    }
  }
  .shrink {
    max-width: max-content;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .shrink + .shrink {
    padding-left: 8px !important;
  }

  .mds-microcopy {
    margin-top: 8px;
    font-size: 14px;
  }
  .cf-heading-title {
    font-weight: 600;
    color: #1e1e1e;
    margin-top: 20px !important;
    font-size: 18px !important;
    @include mds-body-text-m(bold);
    margin-bottom: 8px;
  }
  .cf-heading-align {
    margin-bottom: 5px;
  }

  .cf-alignment {
    margin-top: 10px;
    margin-left: 13px;
    margin-bottom: 50px;
  }
  .cf-label-align {
    margin-bottom: 14px;
    font-size: 17px;
  }
}
</style>
